import React from 'react';
import './Banner.css';

import { Heading, Button } from '../../components'; // Importing reusable Heading and Button components



const Banner = () => {
  return (
    <section className="banner">
      <div className="content">

        {/* Heading component with dynamic props */}
        <Heading title={'聯名, 學習, 並參觀2025年Maker Faire台北.'} subTitle={'特別感謝 MFT 團隊對 WRG 的支持，並額外提供參觀證免費參觀Maker Faire Taipei！'} linear sideHeading />

        <Button link={'Registration'} title={'現在就註冊'} />

      </div>
    </section>
  );
};

export default Banner;